import { Component, output } from '@angular/core';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-locations-empty-box',
  imports: [Button, NgIcon, TranslocoPipe],
  templateUrl: './locations-empty-box.html',
})
export class LocationsEmptyBox {
  clickAdd = output();
}
